import { render, staticRenderFns } from "./PTSA.vue?vue&type=template&id=42e7ef68&"
import script from "./PTSA.vue?vue&type=script&lang=js&"
export * from "./PTSA.vue?vue&type=script&lang=js&"
import style0 from "./PTSA.vue?vue&type=style&index=0&id=42e7ef68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports